<template>
    <div v-if="promotion">
        <div class="app-promotion" v-if="!isPWA && !isNativeApp">
            <div class="downContent">
                <div class="promotion-wrapper">
                    <van-row style="align-items: center;">
                        <van-col span="2" @click="closePromotion">
                            <div class="icon_container">
                                <van-icon name="cross" color="#fff" size="14" />
                            </div>
                        </van-col>
                        <van-col span="3">
                            <div>
                                <img src="@/assets/themeFour/APP6.png" width="40px" height="40px" />
                            </div>
                        </van-col>
                        <van-col span="9">
                            <div style="color: white">
                                <p class="promotion-content" style="color: #fff">
                                    {{ $t('pwaInstructions.title') }}
                                </p>
                            </div>
                        </van-col>
                        <van-col span="2" class="gift-icon" @click="closePromotion">
                            <img src="@/assets/themeFour/pwa-money.png" width="100%" />
                        </van-col>
                        <van-col span="7" class="installBtn" style="text-align: center;">
                            <img src="@/assets/themeFour/btn1.png" alt="" width="100%">
                            <div @click="installApp">
                                <van-row class="buttonContent">
                                    <van-col span="6" offset="2"
                                        style="display: flex; align-items: center;justify-content: right;">
                                        <img src="@/assets/themeFour/download.png" alt="" width="90%">
                                    </van-col>
                                    <van-col span="15" offset="1" style="display: flex; align-items: center;justify-content: center; text-align: center;"
                                        class="download-btn">{{ $t('pwaInstructions.toUpdate') }}</van-col>
                                </van-row>
                                <!-- <van-button class="download-btn"
                                    :style="`pointer-events: visible;    background-image: linear-gradient(0deg,#0167ca -13.77%,#38a8fa 102.34%);`"
                                    size="mini">
                                    {{ $t('pwaInstructions.toUpdate') }}
                                </van-button> -->

                            </div>
                        </van-col>
                    </van-row>
                </div>
            </div>
        </div>
    </div>
    <IosInstruction v-if="isIos && iosInstructionPopup" @closeInstructions="closeInstructions" />
</template>

<script lang="ts" setup>
import { useUserStore } from '@/stores/user';
import { checkIosPWAInstallable, installPWA } from '@/view/home/supportScript';
import IosInstruction from '@/view/iosInstruction/iosInstruction.vue';
import { Capacitor } from '@capacitor/core';
import { ref, onBeforeMount, computed } from 'vue';

const promotion = ref(false);
const isPWA = ref(false);
const isNativeApp = ref(false);
const isIos = ref(false);
const iosInstructionPopup = ref(false);
const userStore = useUserStore()
const pwaDomainInfo = computed(() => userStore.PWAdomainInfo)

const emit = defineEmits(['intallPWA', 'isClosedPWA', 'showPWA']);

const closePromotion = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return }
    promotion.value = false;
    sessionStorage.setItem('openPromotionPopup', 'true');
    emit('isClosedPWA', promotion.value)
};

const closeInstructions = () => {
    iosInstructionPopup.value = false;
};


const installApp = () => {
    const url = pwaDomainInfo.value.domainName
    installPWA({
        url,
        isIos: isIos.value,
        iosPopupRef: iosInstructionPopup,
        emitInstall: () => emit('intallPWA')
    })
}


onBeforeMount(() => {
    isNativeApp.value = Capacitor.isNativePlatform();
    isPWA.value = window.matchMedia('(display-mode: standalone)').matches ||
        (window.navigator.standalone === true) ||
        document.referrer.includes('android-app://');

    promotion.value = true;
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || navigator.standalone;
    if (isStandalone || isNativeApp.value) {
        emit('isClosedPWA', false)
    }
    isIos.value = checkIosPWAInstallable()
});
</script>
<style scoped>
.promotion-wrapper {
    padding: 10px 5px;
    margin: 0 auto;
    height: 45px;
}

.icon_container {
    display: flex;
    justify-content: center;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 0 0 30px 0;
    padding: 10px 0px 10px;
    margin-top: -35px;
    margin-left: -5px;
}

.download-btn {
    color: white;
    font-size: 18px;
    font-weight: 600;
}

.promotion-download {
    line-height: 65px !important;
    width: 65px !important;
}

.blue {
    color: rgb(148 216 252);
}

.green {
    color: #4AA41A;
}

.promotion-content {
    font-size: 15px;
    line-height: 20px;
    margin: 0;
    font-weight: 600;
}

.close-icon {
    display: flex;
    justify-content: center;
    pointer-events: visible;
    cursor: pointer;
}

.close-icon>>>.van-icon {
    font-size: 20px;
}

.installBtn {
    position: relative;
}

.buttonContent {
    height: 90%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}

/* Animation for sliding down when appearing */
@keyframes slideDown {
    from {
        transform: translateY(-100%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* Animation for sliding up when disappearing */
@keyframes slideUp {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(-100%);
        opacity: 0;
    }
}

.app-promotion {
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
}

.app-promotion[style*="display: none"],
.app-promotion.hidden {
    animation: slideUp 0.3s ease-in forwards;
}

.downContent {
    background: rgb(0, 37, 37);
    background-size: cover;
}

@media(max-width: 420px) {
    .download-btn {
        font-size: 14px;
    }

    .promotion-content {
        font-size: 12px !important;
    }

    .close-icon>>>.van-icon {
        font-size: 15px !important;
    }

    .close-icon {
        justify-content: right;
    }
}
</style>